/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Not_SyncedInputs */



/**
* | output |
* | --- |
* | "Not yet saved to server" |
*
* @param {Offline_Not_SyncedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_not_synced = /** @type {((inputs?: Offline_Not_SyncedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Not_SyncedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore sauvegardé sur le serveur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no guardado en el servidor")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ainda não salvo no servidor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non ancora salvato sul server")
	return /** @type {LocalizedString} */ ("Not yet saved to server")
});